import { ArrowUpRight, Check } from "lucide-react";
import { IMAGES, scrollToId } from "@/lib/content";

const CARDS = [
  { id: "residenziale", title: "Residenziale", tag: "Ville, villette e case indipendenti", img: IMAGES.residential,
    points: ["Accumulo con batterie al litio", "Predisposizione wallbox", "Monitoraggio da app"] },
  { id: "commerciale", title: "Commerciale", tag: "Negozi, uffici e strutture ricettive", img: IMAGES.commercial,
    points: ["Copertura dei consumi diurni", "Riduzione dei costi energetici", "Integrazione con pompe di calore"] },
  { id: "industriale", title: "Industriale", tag: "Capannoni e stabilimenti produttivi", img: IMAGES.industrial,
    points: ["Impianti ad alta potenza", "Connessione in media tensione", "Manutenzione programmata"] },
];

export const Solutions = () => (
  <section id="soluzioni" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <div>
          <span className="eyebrow">Soluzioni</span>
          <h2 className="section-title mt-5 max-w-2xl">Un impianto su misura per ogni edificio.</h2>
        </div>
        <p className="max-w-md text-base text-slate-600">Dalla villetta al capannone: dimensioniamo l'impianto sui consumi reali e sui vincoli del tetto.</p>
      </div>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <article
            key={c.id}
            data-testid={`solution-card-${c.id}`}
            className="group flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-shadow duration-300 hover:shadow-xl"
          >
            <div className="overflow-hidden">
              <img src={c.img} alt={c.title} className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="flex flex-1 flex-col p-7">
              <span className="text-xs font-semibold text-slate-400">0{i + 1}</span>
              <h3 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">{c.title}</h3>
              <p className="mt-1 text-sm text-slate-500">{c.tag}</p>
              <ul className="mt-6 space-y-2.5">
                {c.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-sm text-slate-700">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /> {p}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`solution-cta-${c.id}`}
                onClick={() => scrollToId("calcolatore-ai")}
                className="mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 transition-colors hover:text-emerald-600"
              >
                Calcola il tuo impianto <ArrowUpRight className="h-4 w-4" />
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
